import axios from 'axios';

export const GET_SECTION_TYPES = 'front/lesson-section-types';

export function getSectionTypes() {
  return axios.get(GET_SECTION_TYPES);
}
